import React, { useState } from "react";
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  TableRow,
  Tooltip,
  Typography,
  TableHead,
  TableContainer,
  FormControlLabel,
  FormGroup,
  TableBody,
  Table,
  Box,
  Chip,
  Avatar,
  tableCellClasses,
  TablePagination,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  StyledTableCell,
  StyledTableRow,
  styleimg,
  stylename,
  styleRate,
  styleRating,
} from "./CommonTableStyle";
import {
  IOSSwitch,
  StyledCheckbox,
} from "pages/configuration/addCompliance/AddComplianceStyleTab";
import ProgressBar from "components/progressBar/ProgressBar";
import { dateFormate, getTimeFormat, truncateComment } from "utils/utils";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import editmore from "assets/images/moreEditIcon.svg";
import deleteicon from "assets/images/delete.svg";
import deactive from "assets/images/deActivate.svg";
import block from "assets/images/block.svg";
import starImg from "assets/images/smStar.svg";
import profile from "assets/images/profileImg.svg";

export default function CommonTable(props) {
  const { page, rowsPerPage, moreIconData } = props;
  let data = props?.data;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleChangePage = (event, newPage) =>
    props.handleChangePage(event, newPage);
  const handleChangeRowsPerPage = (event) =>
    props?.handleChangeRowsPerPage(event);

  const handleMenuOpen = (event, row) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const onClickTableVendor = (val) => {
    if (props?.from) {
      props?.onClickId(val, props?.from);
    } else {
      props?.onClickTableVendor(val);
    }
  };

  const getConditionalMenuItems = (status, row) => {
    if (props?.tabName === "rideTrack") {
      // 3-dot menu items for Track Trip table (mirrors Ops pattern)
      const tripStatus = status?.toLowerCase();
      const assignStatus = row?.subVendorAssignmentStatus;
      const terminalStatuses = [
        "cancelled",
        "canceled",
        "rejected",
        "completed",
      ];
      if (terminalStatuses.includes(tripStatus)) {
        return [];
      }
      if (assignStatus === "pending") {
        return ["Accept", "Reject"];
      } else if (tripStatus === "alloted" || tripStatus === "allotted") {
        return ["Re-Allot"];
      }
      return [];
    } else if (
      props?.tabName === "cabCategory" ||
      props?.tabName === "feedback"
    ) {
      switch (status?.toLowerCase()) {
        case "active":
          return ["Edit", "Deactivate"];
        case "inactive":
          return ["Activate"];
        case "blocked":
          return ["Unblock"];
        default:
          return ["Edit"];
      }
    } else if (props.tabName === "vehicle") {
      switch (status?.toLowerCase()) {
        case "active":
          return ["Deactivate"];
        case "inactive":
          return ["Activate"];
        case "blocked":
          return ["Unblock"];
        case "Pending":
          return ["Upload Compliance", "Edit"];
        default:
          return ["Upload Compliance"];
      }
    } else if (props?.tabName === "compliance") {
      return ["Edit"];
    } else if (props?.tabName === "unAssignTab") {
      return ["Reassign", "Unassign"];
    } else {
      switch (status?.toLowerCase()) {
        case "active":
          if (props?.tabName === "customer") return ["Block"];
          else return ["Edit", "Deactivate", "Block"];
        case "inactive":
          return ["Activate", "Block"];
        case "blocked":
          return ["Unblock"];
        case "pending":
          if (props?.tabName === "customer") return [];
          else return ["Edit"];
        default:
          return [];
      }
    }
  };

  const onClickMoreIcon = (event, data, type) => {
    event.preventDefault();
    event.stopPropagation();
    props?.onClickMoreIcon(data, type);
    handleMenuClose();
  };

  const onCheckChange = (e, ele, key, id) => {
    props?.onCheckChange(ele, key, id);
  };

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case "blocked":
      case "block":
      case "unblock":
        return block;
      case "edit":
        return editmore;
      case "deactivate":
      case "activate":
        return deactive;
      case "delete":
        return deleteicon;
      default:
        return;
    }
  };

  const tableHeadKey = (className, key) => {
    if (className) return "iconColumn";
    else if (
      key === "dropping" ||
      key === "pickup" ||
      key === "description" ||
      key === "comment"
    )
      return "font14";
    else return "";
  };

  const tableBodyKey = (key) => {
    if (key === "comment" || key === "description")
      return "font14 fontNormal colorGrey";
    else if (key === "location") return "fontNormal";
    else if (key === "dropping" || key === "pickup") return "font14 fontNormal";
  };

  return (
    <div>
      <TableContainer className="tableMain">
        <Table
          sx={{ [`& .${tableCellClasses.root}`]: { borderBottom: "none" } }}
          aria-label="customized table"
        >
          <TableHead className="tableborder">
            <TableRow className="commonTableRow">
              {data?.header?.map((ele) => (
                <StyledTableCell
                  key={ele.label}
                  align="left"
                  className={`comColumnWidth font14 fontMedium ${tableHeadKey(ele.className, ele.key)}`}
                >
                  {ele.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="tableBodyStyle">
            {data?.body && data?.body?.length > 0 ? (
              data?.body?.map((ele, id) => (
                <StyledTableRow
                  key={ele.id}
                  onClick={() =>
                    props?.isClickable ? onClickTableVendor(ele) : undefined
                  }
                  disabled={ele.status === "Blocked"}
                  className={`${props?.isClickable ? "cursor clickableRow" : "cursorDefault"} ${
                    ele?.isVip &&
                    ele?.isVip !== "No" &&
                    ele?.isVip !== "Yes" &&
                    "vip"
                  } ${ele.gender === "Female" ? "bgFemale" : ""}`}
                >
                  {data?.header?.map((val, idx) => (
                    <StyledTableCell
                      align="left"
                      key={val.label}
                      disabled={ele.status === "Blocked"}
                      className={`comRowChildWidth ${tableBodyKey(ele.key)}`}
                    >
                      {val.key === ele["imageflag"] ? (
                        <Box style={styleimg}>
                          {val.key === ele["imageflag"] && (
                            <img
                              style={stylename}
                              className="width33"
                              src={ele?.avtar?.url ? ele?.avtar?.url : profile}
                              alt="vendorimage"
                            />
                          )}
                          <span>
                            <Tooltip title={ele[val.key]} placement="bottom">
                              {truncateComment(ele[val.key], 20)}
                            </Tooltip>{" "}
                            <br />
                            {ele?.category && (
                              <span className="font12 fontNormal colorGrey">
                                {ele.category}
                              </span>
                            )}
                          </span>
                        </Box>
                      ) : val.key === "rating" ? (
                        <Box style={styleimg}>
                          {ele[val.key] && ele[val.key] !== null && (
                            <img
                              src={starImg}
                              alt="vendorimage"
                              className="width16"
                              style={stylename}
                            />
                          )}
                          <span className="fontWeight400">{ele[val.key]}</span>
                        </Box>
                      ) : val.key === "documentname" ? (
                        <Box style={styleimg}>
                          {ele.star && (
                            <img
                              src={ele.star}
                              alt="vendorimage"
                              className="feedbackStar"
                            />
                          )}
                          <div style={styleRate}>{ele[val.key]}</div>
                          <div style={styleRating}>{ele.ratingmsg}</div>
                        </Box>
                      ) : val.key === "starValue" ? (
                        <Box style={styleimg}>
                          <img
                            src={starImg}
                            alt="vendorimage"
                            className="width16"
                            style={stylename}
                          />
                          <span className="fw600">
                            {ele[val.key] ? ele[val.key] : 0}
                          </span>
                          <span>&nbsp;Rating</span>
                        </Box>
                      ) : val.key === ele["currencyFlag"] ? (
                        <Box
                          className={
                            ele["currencyFlag"] === "price" ? "w100" : null
                          }
                        >
                          <span>
                            <Tooltip
                              title={"₹ " + ele[val.key]}
                              placement="bottom"
                            >
                              {ele["currencyFlag"] === "price"
                                ? truncateComment("₹ " + ele[val.key], 8)
                                : "₹ " + ele[val.key]}
                            </Tooltip>
                          </span>
                        </Box>
                      ) : val.key === "carType" ? (
                        <Box>
                          <div>{ele[val.key]}</div>
                          <div className="font12 colorGrey">
                            {ele.regNumber}
                          </div>
                        </Box>
                      ) : val.key === "documentStatus" ? (
                        <Box>
                          <div className="progressAlign">
                            <span className="tableProgressBar">
                              <ProgressBar
                                approvedCount={ele?.ApprovedCount}
                                rejectCount={ele?.rejectCount}
                                totalRequired={ele?.totalRequired}
                              />
                            </span>
                            <span className="tableProgressBarText">
                              {ele[val.key]}
                            </span>
                          </div>
                        </Box>
                      ) : val.key === "comment" ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 20)}
                        </Tooltip>
                      ) : val.key === "email" ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                        </Tooltip>
                      ) : ele["pickup"] === val.key ||
                        val.key === "sourceAddress" ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                        </Tooltip>
                      ) : ele["drop"] === val.key ||
                        val.key === "destinationAddress" ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                          {ele?.completedAt && (
                            <div className="font10 colorGrey">
                              {dateFormate(
                                ele["completedAt"],
                                "DD MMM YYYY, hh:mm a",
                              )}
                            </div>
                          )}
                        </Tooltip>
                      ) : val.label === "Rep. Time" ? (
                        <Box>
                          <Typography variant={"body2"}>
                            {getTimeFormat(ele["scheduledTime"])}
                          </Typography>
                        </Box>
                      ) : val.key === "joinDate" ? (
                        dateFormate(ele[val.key], "DD MMMM YYYY")
                      ) : val.key === "updatedAt" ? (
                        dateFormate(ele[val.key], "DD MMMM YYYY")
                      ) : val.key === "scheduledTime" ? (
                        // --- NEW: Check the header (val) for format flags ---
                        val.isTimeFormat ? (
                          getTimeFormat(ele[val.key])
                        ) : (
                          dateFormate(ele[val.key], "DD MMMM YYYY")
                        )
                      ) : val.key === "createdAt" ||
                        val.key === "bookingDate" ? (
                        dateFormate(ele[val.key], "DD MMMM YYYY")
                      ) : val.isDateFormat ? (
                        // Catch any other date formats using the header flag
                        dateFormate(ele[val.key], "DD MMMM YYYY")
                      ) : val.isTimeFormat ? (
                        // Catch any other time formats using the header flag
                        getTimeFormat(ele[val.key])
                      ) : val.key === "status" &&
                        props?.tabName === "rideTrack" ? (
                        ele?.status === "Booked" &&
                        ele?.subVendorAssignmentStatus === "pending" ? (
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                props?.onClickMoreIcon(ele, "Accept");
                              }}
                              size="small"
                              title="Accept"
                            >
                              <TaskAltIcon sx={{ color: "green" }} />
                            </IconButton>

                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                props?.onClickMoreIcon(ele, "Reject");
                              }}
                              size="small"
                              title="Reject"
                            >
                              <HighlightOffIcon sx={{ color: "red" }} />
                            </IconButton>
                          </Box>
                        ) : ele?.status === "Booked" &&
                          ele?.subVendorAssignmentStatus === "accepted" ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              props?.onClickMoreIcon(ele, "Allot");
                            }}
                          >
                            Allot
                          </Button>
                        ) : ele?.subVendorAssignmentStatus === "rejected" ? (
                          <Tooltip
                            title={
                              <Box sx={{ p: 0.5 }}>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  sx={{ fontWeight: 600, color: "#000" }}
                                >
                                  Rejected by:{" "}
                                  {ele.subVendorRejectedBy ||
                                    ele.subVendorRejectedByName ||
                                    ele.additionalInfo?.subVendorRejectedBy ||
                                    ele.additionalInfo?.subVendorAssignment
                                      ?.rejectedBy ||
                                    ele.additionalInfo
                                      ?.subVendorAssignmentAction?.[0]
                                      ?.actionBy ||
                                    ele.additionalInfo
                                      ?.subVendorAssignmentAction?.[0]
                                      ?.userName ||
                                    "Sub-Vendor"}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  sx={{ color: "#000" }}
                                >
                                  Reason: {ele?.subVendorRejectedReason || "—"}
                                </Typography>
                              </Box>
                            }
                            arrow
                            placement="top"
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: "#fff",
                                  color: "#000",
                                  boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                                  border: "1px solid #e0e0e0",
                                  "& .MuiTooltip-arrow": {
                                    color: "#fff",
                                    "&::before": {
                                      border: "1px solid #e0e0e0",
                                    },
                                  },
                                },
                              },
                            }}
                          >
                            <Typography
                              className="textTransformInherit fontNormal CancelledBtn"
                              variant="contained"
                              disabled={ele.status === "Blocked"}
                              sx={{
                                display: "inline-block",
                                cursor: "pointer",
                              }}
                            >
                              Rejected
                            </Typography>
                          </Tooltip>
                        ) : (
                          <Typography
                            className={`textTransformInherit fontNormal ${ele?.status + "Btn"}`}
                            variant="contained"
                            disabled={ele.status === "Blocked"}
                          >
                            {ele[val.key]}
                          </Typography>
                        )
                      ) : val.key === "status" ? (
                        props.tabName === "assignTrip" ? (
                          <Box>
                            <Typography
                              className={`textTransformInherit fontNormal ${
                                ele.subVendorAssignmentStatus === "rejected"
                                  ? "CancelledBtn"
                                  : ele?.status + "Btn"
                              }`}
                              variant="contained"
                              disabled={ele.status === "Blocked"}
                            >
                              {ele.subVendorAssignmentStatus === "rejected"
                                ? "Rejected"
                                : ele[val.key]}
                            </Typography>
                            {ele.subVendorAssignmentStatus === "rejected" &&
                              ele.subVendorRejectedReason && (
                                <Typography
                                  variant="body2"
                                  color="error"
                                  sx={{
                                    fontSize: "11px",
                                    mt: 0.5,
                                    fontWeight: 500,
                                  }}
                                >
                                  Reason: {ele.subVendorRejectedReason}
                                </Typography>
                              )}
                          </Box>
                        ) : (
                          <Typography
                            className={`textTransformInherit fontNormal ${ele?.status + "Btn"}`}
                            variant="contained"
                            disabled={ele.status === "Blocked"}
                          >
                            {ele[val.key]}
                          </Typography>
                        )
                      ) : val.key === "customerName" ? (
                        <Box>
                          <Box display={"flex"} alignItems={"center"}>
                            <Tooltip title={ele[val.key]} placement="bottom">
                              <Typography variant={"body2"} className="pr10">
                                {ele[val.key]
                                  ? truncateComment(ele[val.key], 10)
                                  : "NA"}
                              </Typography>
                            </Tooltip>
                            {ele.isVip && (
                              <Typography
                                variant={"body6"}
                                ml={1}
                                className="vipBadge colorWhite"
                              >
                                VIP
                              </Typography>
                            )}
                          </Box>
                          <Typography
                            variant={"body4"}
                            className="colorGrey"
                            component={"p"}
                          >
                            {ele["gender"]}
                          </Typography>
                        </Box>
                      ) : val.key === "action" ? (
                        props.tabName === "assignTrip" ? (
                          ele.status?.toLowerCase() === "alloted" ||
                          ele.status?.toLowerCase() === "allotted" ||
                          ele.status?.toLowerCase() === "assigned" ? (
                            <Button
                              variant="contained"
                              color="warning"
                              size="small"
                              sx={{
                                textTransform: "none",
                                borderRadius: "6px",
                              }}
                              onClick={() => onClickTableVendor(ele)}
                            >
                              Re-Allot
                            </Button>
                          ) : ele.subVendorAssignmentStatus === "pending" ? (
                            <Box sx={{ display: "flex", gap: 1 }}>
                              <Button
                                variant="contained"
                                color="success"
                                size="small"
                                sx={{
                                  textTransform: "none",
                                  borderRadius: "6px",
                                  backgroundColor: "#2e7d32",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props.onAcceptTrip(ele);
                                }}
                              >
                                Accept
                              </Button>
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{
                                  textTransform: "none",
                                  borderRadius: "6px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props.onRejectTrip(ele);
                                }}
                              >
                                Reject
                              </Button>
                            </Box>
                          ) : ele.subVendorAssignmentStatus === "rejected" ? (
                            <Typography
                              variant="body2"
                              color="error"
                              sx={{ fontWeight: 500 }}
                            >
                              Rejected
                            </Typography>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              sx={{
                                textTransform: "none",
                                borderRadius: "6px",
                              }}
                              onClick={() => onClickTableVendor(ele)}
                            >
                              Allot
                            </Button>
                          )
                        ) : (
                          <Button
                            className={`textTransformInherit fontNormal ${ele?.action?.toLowerCase() + "Btn"}`}
                            variant="contained"
                            onClick={() => {
                              onClickTableVendor(ele);
                            }}
                          >
                            {ele[val.key]}
                          </Button>
                        )
                      ) : val.key === "icon" ? (
                        getConditionalMenuItems(ele?.status, ele)?.length ===
                        0 ? (
                          "-"
                        ) : (
                          <div className="floatRight">
                            <Button
                              onClick={(event) => handleMenuOpen(event, ele)}
                            >
                              <div className="colorGrey">
                                {<MoreVertIcon />}
                              </div>
                            </Button>
                            <Menu
                              anchorEl={anchorEl}
                              open={Boolean(
                                anchorEl && selectedRow?.id === ele.id,
                              )}
                              onClose={handleMenuClose}
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                            >
                              {moreIconData && moreIconData.length > 0
                                ? moreIconData.map((moreData, idx) => (
                                    <MenuItem
                                      onClick={(e) =>
                                        onClickMoreIcon(e, ele, moreData?.name)
                                      }
                                      selected={selectedItem === moreData?.name}
                                      key={moreData?.id}
                                    >
                                      {moreIconSrc(moreData?.name)?.length >
                                        0 && (
                                        <span className="marginRight10 alignItem">
                                          <img
                                            src={moreIconSrc(moreData?.name)}
                                            alt={moreData?.name}
                                          />
                                        </span>
                                      )}
                                      <Typography className="font16 fontSemi">
                                        {moreData?.name}
                                      </Typography>
                                    </MenuItem>
                                  ))
                                : getConditionalMenuItems(ele?.status, ele).map(
                                    (moreData, idx) => (
                                      <MenuItem
                                        onClick={(e) =>
                                          onClickMoreIcon(e, ele, moreData)
                                        }
                                        selected={selectedItem === moreData}
                                        key={moreData}
                                      >
                                        {moreIconSrc(moreData)?.length > 0 && (
                                          <span className="marginRight10 alignItem">
                                            <img
                                              src={moreIconSrc(moreData)}
                                              alt={moreData}
                                            />
                                          </span>
                                        )}
                                        <Typography className="font16 fontSemi">
                                          {moreData}
                                        </Typography>
                                      </MenuItem>
                                    ),
                                  )}
                            </Menu>
                          </div>
                        )
                      ) : val.key === "amount" &&
                        props.from === "dashboardRide" ? (
                        <Grid>
                          <div>{ele[val.key]}</div>
                          {ele?.status && (
                            <div className={`font12 ${ele.status + "Btn"}`}>
                              {ele["status"]}
                            </div>
                          )}
                        </Grid>
                      ) : val.key === "pickup" && props.from === "rideTrack" ? (
                        <Grid>
                          <div>{ele[val.key]}</div>
                          {ele?.pickupDate && (
                            <div className="font10 colorGrey">
                              {ele["pickupDate"]}
                            </div>
                          )}
                        </Grid>
                      ) : val.key === "car" && props.from === "rideTrack" ? (
                        <Grid>
                          <div>{ele[val.key]}</div>
                          {ele?.pickupDate && (
                            <div className="font10 colorGrey">
                              {ele["carNumber"]}
                            </div>
                          )}
                        </Grid>
                      ) : val.key === "isActive" ? (
                        <FormGroup className="switchButton">
                          <FormControlLabel
                            control={
                              <IOSSwitch
                                checked={ele[val.key]}
                                onChange={(e) => {
                                  onCheckChange(e, ele, val.key, id);
                                }}
                              />
                            }
                          />
                        </FormGroup>
                      ) : val.key === "isMandatory" ? (
                        <StyledCheckbox
                          checked={ele[val.key]}
                          onChange={(e) => {
                            onCheckChange(e, ele, val.key, id);
                          }}
                        />
                      ) : val.key === "isExpiring" ? (
                        <StyledCheckbox
                          checked={ele[val.key]}
                          onChange={(e) => {
                            onCheckChange(e, ele, val.key, id);
                          }}
                        />
                      ) : val.key === "tags" ? (
                        ele[val.key]?.toString()?.split(",")?.join(", ")
                      ) : val.key === "Facilities" ? (
                        ele?.Facilities?.map((data) => (
                          <Chip
                            className="chipSizeStyle"
                            avatar={
                              <Avatar alt="Natacha" src={data?.img?.url} />
                            }
                            label={data?.name}
                            variant="outlined"
                          />
                        ))
                      ) : val.key === ele["isDateFormat"] ? (
                        dateFormate(ele[val.key], "DD MMMM YYYY")
                      ) : val.key === ele["isTimeFormat"] ? (
                        getTimeFormat(ele[val.key])
                      ) : (
                        ele[val.key]
                      )}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={data?.header?.length} align="center">
                  <CommonNoDataFound />
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.body && data?.body?.length > 0 && data?.totalCount > 10 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={data?.totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </div>
  );
}
